import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { SafeHtmlPipe } from 'src/app/templates/safe.pipe';
import { ContentService } from '../../../services/content.service';

@Component({
  selector: 'app-team-member-strengths',
  templateUrl: './team-member-strengths.component.html',
  styleUrls: ['./team-member-strengths.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [SafeHtmlPipe, CommonModule],
})
export class TeamMemberStrengthsComponent implements OnInit {
  @Input() mbtiType: string;
  isApiDataLoaded: boolean = false;
  reportContent: string;

  constructor(private contentService: ContentService) {}

  ngOnInit() {
    this.contentService.getReport('TeamsIndividualStrengths', this.mbtiType).subscribe((data) => {
      this.reportContent = data.content;
      this.isApiDataLoaded = true;
    });
  }
}
